import { render, staticRenderFns } from "./SigninPage.vue?vue&type=template&id=36e6ad5f&"
import script from "./SigninPage.vue?vue&type=script&lang=js&"
export * from "./SigninPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports